import { Helmet, HelmetProvider } from "react-helmet-async";
import { GlobalStyle } from "./GlobalStyle";
import Router from "./Router";
import { useState } from "react";

const App = () => {
  const [render, setRender] = useState(true);
  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>CloudN : 본사통합관제센터</title>
        </Helmet>
      </HelmetProvider>
      <GlobalStyle />

      <Router render={render} />
    </>
  );
};

export default App;
